import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FastField } from 'formik';
import Autosuggest from 'react-autosuggest';
import { graphql } from 'react-apollo';
import THEATER_AUTOCOMPLETE_QUERY from '../../../graphql/TheaterAutocomplete';


class TheaterAutocompleteField extends Component {
  constructor(props) {
    super(props);

    this.state = {
      theaterSuggestions: [],
    };
  }

  onTheaterSuggestionsFetchRequested = ({ value }) => {
    this.props.TheaterAutocomplete.refetch({
      q: value,
    }).then((res) => {
      if (res.data) {
        this.setState({
          theaterSuggestions: res.data.search.theaters,
        });
      }
    });
  };

  onTheaterSuggestionsClearRequested = () => {
    this.setState({
      theaterSuggestions: [],
    });
  };

  getSuggestionValue = suggestion => suggestion;

  shouldRenderSuggestions = () => true;

  renderSuggestion = suggestion => <div>{suggestion.name}</div>;


  render() {
    return (
      <FastField name={this.props.name}>
        {({ field, form }) => (
          <div className="form-group">
            <label>{this.props.label}</label>
            <Autosuggest
              suggestions={this.state.theaterSuggestions}
              onSuggestionsFetchRequested={this.onTheaterSuggestionsFetchRequested}
              onSuggestionsClearRequested={this.onTheaterSuggestionsClearRequested}
              getSuggestionValue={this.getSuggestionValue}
              shouldRenderSuggestions={this.shouldRenderSuggestions}
              renderSuggestion={this.renderSuggestion}
              inputProps={{
                placeholder: 'Escribe el nombre de un teatro',
                value: form.values[field.name].name,
                onBlur: () => {
                  if (!{}.hasOwnProperty.call(form.values[field.name], 'id')) {
                    form.setFieldValue(field.name, { name: '' });
                    form.setFieldTouched(field.name, true);
                  }
                },
                onChange: (event, { newValue }) => {
                  if (typeof newValue === 'string') {
                    form.setFieldValue(field.name, { name: newValue });
                    return;
                  }
                  form.setFieldValue(field.name, newValue);
                },
              }}
            />
            {form.touched[field.name] && form.errors[field.name] && (
              <span className="input-text-error-msg">
                Debes seleccionar un teatro asociado
              </span>
            )}
          </div>
        )}
      </FastField>
    );
  }
}

TheaterAutocompleteField.propTypes = {
  TheaterAutocomplete: PropTypes.object.isRequired,
};

const withTheaterAutocomplete = graphql(THEATER_AUTOCOMPLETE_QUERY, {
  name: 'TheaterAutocomplete',
  options: {
    variables: { q: '' },
    fetchPolicy: 'no-cache',
  },
});

export default withTheaterAutocomplete(TheaterAutocompleteField);



// WEBPACK FOOTER //
// ./src/containers/Others/TheaterAutocompleteField/index.js